import { GripVertical, ChevronLeft, ChevronRight } from "lucide-react";
import { PageThumb, noop } from "./shared";

export const PageOrderPanel = ({ thumbs, order, selectedPages, onToggle, onReorder, onMove }) => {
  const outputOrder = order.filter((p) => selectedPages.has(p));
  return (
    <div className="border border-hairline rounded-lg bg-page p-3 mb-2" data-testid="page-order-panel">
      <div className="flex items-center justify-between mb-3 gap-3">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist">Drag pages into deal order</span>
        <span className="font-mono text-[10px] text-fog" data-testid="page-order-count">{selectedPages.size} selected</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-[420px] overflow-y-auto pr-1">
        {order.map((pageNo, visualIndex) => {
          const page = thumbs.find((p) => p.page === pageNo);
          if (!page) return null;
          const selected = selectedPages.has(pageNo);
          const outputIndex = outputOrder.indexOf(pageNo);
          return (
            <div
              key={pageNo}
              draggable
              onDragStart={(e) => e.dataTransfer.setData("text/doclyx-page", String(pageNo))}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                onReorder(Number(e.dataTransfer.getData("text/doclyx-page")), pageNo);
              }}
              onClick={() => onToggle(pageNo)}
              data-testid={`page-order-item-${pageNo}`}
              className={`relative cursor-grab active:cursor-grabbing rounded-md transition-opacity duration-200 ${selected ? "" : "opacity-35"}`}
            >
              <span className="absolute left-1.5 top-1.5 z-10 flex items-center gap-1 rounded-full bg-black/70 border border-white/10 px-2 py-1 font-mono text-[9px] text-white" data-testid={`page-order-position-${pageNo}`}>
                <GripVertical className="w-3 h-3" strokeWidth={1.5} /> {selected ? outputIndex + 1 : "OFF"}
              </span>
              <PageThumb page={page} rects={[]} editable={false} compact={false} onAdd={noop} onRemove={noop} />
              <span className="mt-2 flex justify-center gap-1 sm:absolute sm:right-1.5 sm:top-1.5 sm:mt-0 sm:justify-end">
                <button
                  type="button"
                  data-testid={`page-move-left-${pageNo}`}
                  disabled={visualIndex === 0}
                  onClick={(e) => { e.stopPropagation(); onMove(pageNo, -1); }}
                  className="w-7 h-7 rounded-full bg-black/70 border border-white/10 text-white disabled:opacity-25 flex items-center justify-center"
                >
                  <ChevronLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
                </button>
                <button
                  type="button"
                  data-testid={`page-move-right-${pageNo}`}
                  disabled={visualIndex === order.length - 1}
                  onClick={(e) => { e.stopPropagation(); onMove(pageNo, 1); }}
                  className="w-7 h-7 rounded-full bg-black/70 border border-white/10 text-white disabled:opacity-25 flex items-center justify-center"
                >
                  <ChevronRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                </button>
              </span>
            </div>
          );
        })}
      </div>
      <p className="font-mono text-[10px] text-mist mt-3">Drag or use arrows to reorder · Click a page to include or exclude it · Type an advanced range below to override</p>
    </div>
  );
};
